import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import classes from "./styles.module.css"; 
import { Link } from "react-router-dom"
import APIConfig from "../../../../api/APIConfig";
import ReactLoading from "react-loading";

import {
    Box,
    Center,
    Heading,
    Text,
    Button,
    VStack,
    StackDivider,
    HStack,
} from '@chakra-ui/react';

function DetailRekeningPeserta() {
    const [namaRekening, setNamaRekening] = useState('');
    const [namaBank, setNamaBank] = useState('');
    const [nomorRekening, setNomorRekening] = useState('');
    const [spinner, setSpinner] = useState(false);  

    const getPesertaById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setNamaBank(data.namaBank);
        setNamaRekening(data.namaRekening);
        setNomorRekening(data.nomorRekening);

        setSpinner(false);
    };

    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    }, []);

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <Center py={6}>
        <VStack align='stretch' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'3xl'}>
                Profil
            </Text>
            <HStack color={'gray.500'} pb={3}>
                <Link to="/peserta/profile"> Profil </Link>
                <p> / </p>
                <Link to={`/peserta/profile/rekening/${id}`}> Detail Rekening </Link>
            </HStack>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                divider={<StackDivider borderColor='gray.200' />}
                spacing={4}
                align='stretch'
                >
                    <Heading
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Detail Rekening
                    </Heading>
                    <div justifyContent='left' justifyItems='left'>
                        <h3 className={classes.h} >Nama Rekening</h3>
                        <p className={classes.p}>{namaRekening}</p>
                    </div>

                    <div>
                        <h3 className={classes.h}>Nama Bank</h3>
                        <p className={classes.p}>{namaBank}</p> 
                    </div>

                    <div>
                        <h3 className={classes.h}>Nomor Rekening</h3>
                        <p className={classes.p}>{nomorRekening}</p> 
                    </div>

                </VStack>
                <Center pt={6}>
                    <Link to={`/peserta/profile/isi-rekening/${id}`} >
                        <Button p={6} w='100%' rounded={'xl'} colorScheme='purple' variant='solid'>
                        Edit Detail Rekening
                        </Button>
                    </Link>
                </Center>
            </Box>
        </VStack>
        </Center>
    );
}

export default DetailRekeningPeserta;
